/* eslint-disable  */
import React, { useState, useEffect } from 'react';
import { FaChevronCircleUp, FaChevronCircleDown, FaPlay, FaHome, FaAngleLeft, FaHandMiddleFinger } from 'react-icons/fa';
import { VscDebugRestart } from 'react-icons/vsc';





import { connectWebSocket } from '../../lib/cmra-data-collection';

import Blocks from '../../containers/blocks.jsx';
import UnityPane from '../../containers/unity-pane.jsx';
import styles from './cdg1_gui.css';

import { saveLocalProject, getProject, clearStore } from '../../lib/cmra-local-store';
import { setProjectUnchanged } from "../../reducers/project-changed";

import { useDispatch } from "react-redux";


export const CDG1 = ({ layout, canUseCloud, blocksTabVisible, basePath, vm, stageSizeMode, scratchGui }) => {

  const [isUnityFullScreen, setUnityFullScreen] = useState(true);
  const [unityWidth, setUnityWidth] = useState(960/3);
  const [unityHeight, setUnityHeight] = useState(600 / 3);
  const [hideMenu, setHideMenu] = useState(true);
  const [modifiedBehavior, setModifiedBehavior] = useState(false)
  const [selectedItem, setSelectedItem] = useState(0);

  const programs = [
    {"targets":[{"isStage":true,"name":"Stage","variables":{"`jEk@4|i[#Fk?(8x)AV.-my variable":["my variable",0]},"lists":{},"broadcasts":{},"blocks":{"g;}C@.TcP4NMdA{}WHeH":{"opcode":"cdg3_event_when_tracking_ball_lands","next":"WT5-s.b0k93%t?!RE,u$","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":62,"y":56},"WT5-s.b0k93%t?!RE,u$":{"opcode":"cdg3_action_move_to","next":"/e2-NZM?Lg|hjd8u*/uY","parent":"g;}C@.TcP4NMdA{}WHeH","inputs":{},"fields":{"UNIT":["Tracking Ball",null]},"shadow":false,"topLevel":false},"/e2-NZM?Lg|hjd8u*/uY":{"opcode":"cdg3_action_start_capturing","next":null,"parent":"WT5-s.b0k93%t?!RE,u$","inputs":{},"fields":{},"shadow":false,"topLevel":false}},"comments":{},"currentCostume":0,"costumes":[{"assetId":"cd21514d0531fdffb22204e0ec5ed84a","name":"backdrop1","md5ext":"cd21514d0531fdffb22204e0ec5ed84a.svg","dataFormat":"svg","rotationCenterX":240,"rotationCenterY":180}],"sounds":[{"assetId":"83a9787d4cb6f3b7632b4ddfebf74367","name":"pop","dataFormat":"wav","format":"","rate":44100,"sampleCount":1032,"md5ext":"83a9787d4cb6f3b7632b4ddfebf74367.wav"}],"volume":100,"tempo":60,"videoTransparency":50,"videoState":"on","textToSpeechLanguage":null}],"monitors":[],"extensions":[],"meta":{"semver":"3.0.0","vm":"0.5.2","agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/105.0.0.0 Safari/537.36"}},
    {"targets":[{"isStage":true,"name":"Stage","variables":{"`jEk@4|i[#Fk?(8x)AV.-my variable":["my variable",0]},"lists":{},"broadcasts":{},"blocks":{"?68zve^/DORdtEg}_wk1":{"opcode":"cdg3_event_when_no_toxibots_near","next":"B?k:nGgAH[,vUFA_FpYL","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":114,"y":328},"B?k:nGgAH[,vUFA_FpYL":{"opcode":"cdg3_action_follow","next":null,"parent":"?68zve^/DORdtEg}_wk1","inputs":{},"fields":{"UNIT":["Player",null]},"shadow":false,"topLevel":false},"}6S;7M@l}[q;ZfFX8.Q=":{"opcode":"cdg3_event_when_toxibots_get_near","next":"1S97ak$R0jUPvqpp)Cj6","parent":null,"inputs":{},"fields":{},"shadow":false,"topLevel":true,"x":105,"y":148},"1S97ak$R0jUPvqpp)Cj6":{"opcode":"cdg3_action_start_capturing","next":null,"parent":"}6S;7M@l}[q;ZfFX8.Q=","inputs":{},"fields":{},"shadow":false,"topLevel":false},"E!y7~!mkfySxo~y(5mIr":{"opcode":"cdg3_event_when_player_clubhouse","next":"7S~w6JeHW}bgtydq@IB)","parent":null,"inputs":{},"fields":{"MOVEMENT":["leaves",null]},"shadow":false,"topLevel":true,"x":116,"y":510},"7S~w6JeHW}bgtydq@IB)":{"opcode":"cdg3_action_follow","next":null,"parent":"E!y7~!mkfySxo~y(5mIr","inputs":{},"fields":{"UNIT":["Player",null]},"shadow":false,"topLevel":false}},"comments":{},"currentCostume":0,"costumes":[{"assetId":"cd21514d0531fdffb22204e0ec5ed84a","name":"backdrop1","md5ext":"cd21514d0531fdffb22204e0ec5ed84a.svg","dataFormat":"svg","rotationCenterX":240,"rotationCenterY":180}],"sounds":[{"assetId":"83a9787d4cb6f3b7632b4ddfebf74367","name":"pop","dataFormat":"wav","format":"","rate":44100,"sampleCount":1032,"md5ext":"83a9787d4cb6f3b7632b4ddfebf74367.wav"}],"volume":100,"tempo":60,"videoTransparency":50,"videoState":"on","textToSpeechLanguage":null}],"monitors":[],"extensions":[],"meta":{"semver":"3.0.0","vm":"0.5.2","agent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.159 Safari/537.36"}}
  ]

  const width = "100%";
  const height = "100%";
  const gameHeight = 600 / 3;
  const gameWidth = 960 / 3;

 
  


  const dispatch = useDispatch();


  const mainWrapper = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    // margin: 50,
    height: window.innerHeight,
    width: window.innerWidth,
    overflow: 'hidden',
  }



  useEffect(() => {
    if (vm.runtime.unity == undefined)
      return;
    if (isUnityFullScreen) {
      setUnityWidth(window.innerWidth);
      setUnityHeight(window.innerHeight);

    }
    window.vm = () => console.log(vm.toJSON());
    window.clearStore = () => clearStore();
    clearStore(); // Remove this if you want to store data over sessions
   },
    [vm.runtime.unity])
  
    useEffect( () => {
      if (selectedItem == null)
        return;
      var key = "Program" + selectedItem;
      var prog = getProject(key);
      if (prog) {
        vm.loadProject(prog).then(saveLocalProject(key, JSON.stringify(prog))).then(cleanProgram);
      }
    }, [selectedItem]);

  const openPI = (_event, /*(bot = 0, mode = "Fetch", is_mid_game = false*/) => {
   
    setUnityFullScreen(false);
    setUnityWidth(gameWidth);
    setUnityHeight(gameHeight);
  }

  const closePI = () => {
    if (isUnityFullScreen) {
      return;
    }
    if (vm.runtime.unity == undefined) {
      return;
    }
    const outgoing = {
      topic: 'game_status',
      message: {
          method: 'OnFocusUnity'
      }
    };
    const message = JSON.stringify(outgoing);
    vm.runtime.unity.send('UnityMessenger', 'UnityMessengerDispatcher', message);


    saveLocalProject("Program" + selectedItem, JSON.stringify(vm.toJSON()));
   // setHideBlockly(true);
    setUnityFullScreen(true);
    setUnityWidth(window.innerWidth);
    setUnityHeight(window.innerHeight);
    const outgoing2 = {
      topic: 'data_log',
      message: {
        method: 'browserLog',
        parameters: {
          ACTOR: "player",
          VERB: "disable_shop",
          OBJECT: "programming_shop",
          program: JSON.stringify(vm.toJSON()).replace(/%/g, "$@$@")
        }
      }
    };
    const message2 = JSON.stringify(outgoing2);
    vm.runtime.unity.send('UnityMessenger', 'UnityMessengerDispatcher', message2);
  }
  

  const cleanProgram = () => {
    dispatch(setProjectUnchanged());
  }
  const resetProgram = () => {
    var key = "Program" + selectedItem;
    var prog = programs[selectedItem];
     vm.loadProject(prog).then(saveLocalProject(key, JSON.stringify(prog))).then(cleanProgram);
  }


  const getDropDownList = () => {
    return ["Follow Ball", "Follow Player"];
  }
  const onOptionClicked = value => () => {
    
    console.log(value, this);

    saveLocalProject("Program" + selectedItem, JSON.stringify(vm.toJSON()));
    setSelectedItem(value);
    setHideMenu(true);
  }
  const createNewPlaySession = () => {
    console.log("CONNECTING TO WEBSOCKETS...CREATING ANOTHER PLAY SESSION");
    
    connectWebSocket();
  }
 
  const loadDefaultProject = () => {
    console.log("TODO loading default");

    if (localStorage.getItem("Program0") == null) {
      saveLocalProject("Program0", JSON.stringify(programs[0]));
    }
    
    if (localStorage.getItem("Program1") == null) {
      saveLocalProject("Program1", JSON.stringify(programs[1]));
    }
   //console.log("Loading to vm ", JSON.parse(localStorage.getItem(fetch_key)));
    vm.loadProject(getProject("Program0")).then(cleanProgram);

  }


  const playButton = () => {

   closePI();
  }
  const toggleDropdown = () => {
    setHideMenu(!hideMenu)
  }


  


  return (
    <div>
      <div style={mainWrapper}>
        
        <div className={styles.blocks_wrapper}>
              <Blocks
                canUseCloud={canUseCloud}
                grow={1}
                isVisible={blocksTabVisible}
                options={{
                  media: `${basePath}static/blocks-media/`
                }}
                stageSize={stageSizeMode}
                vm={vm}
                layout={layout}
          />
           <div className={styles.dropdown_wrapper}>
                  {
                    hideMenu ? 
                    <span><FaChevronCircleDown/></span>
                    :
                    <span><FaChevronCircleUp/></span>
                  }
                    <div className={styles.dropdown_header_wrapper}>
                      <label>Beastie's Programs</label>
                      <div className={styles.dropdown_header} onClick={toggleDropdown}>
                {
                getDropDownList()[selectedItem]
                }
                      </div>
                      {
                        modifiedBehavior ?
                        <div className={styles.modified_indicator}>Modified</div> :
                        null
                      }
                    </div>
                    {
                      hideMenu ? 
                      null :
                      <div className={styles.dropdown_list}>
                        {getDropDownList().map((program, index) => 
                      <div key={Math.random()} onClick={onOptionClicked(index)} className={styles.list_item}>
                        {program}
                      </div>
                    )}
                      </div>
                    }
          </div>
              
              <div onClick={playButton} className={styles.play_button}>
                <label>Play</label>
                <span><FaPlay className="fa-lg"/></span>
          </div>
          <div onClick={resetProgram} className={styles.reset_button}>
                  <span><VscDebugRestart /></span>
                </div>
          
        </div>

        <div onClick={() => {
          
          closePI();
        }} >
          <UnityPane loadDefaultProject={loadDefaultProject} width={unityWidth} height={unityHeight} isFullscreen={isUnityFullScreen} openPI={openPI} disableCS2N={true} createNewPlaySession={createNewPlaySession} />
          </div>
      </div>
      

   
    </div>
  )


  
}
